<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M2.25,24C1.009,24,0,22.991,0,21.75V5.25C0,4.009,1.009,3,2.25,3H6V0.75C6,0.336,6.336,0,6.75,0S7.5,0.336,7.5,0.75V3h9
		V0.75C16.5,0.336,16.836,0,17.25,0S18,0.336,18,0.75V3h3.75C22.991,3,24,4.009,24,5.25v16.5c0,1.241-1.009,2.25-2.25,2.25H2.25z
		 M1.5,21.75c0,0.414,0.336,0.75,0.75,0.75h19.5c0.414,0,0.75-0.336,0.75-0.75V10.5h-21V21.75z M22.5,9V5.25
		c0-0.414-0.336-0.75-0.75-0.75H18V6c0,0.414-0.336,0.75-0.75,0.75S16.5,6.414,16.5,6V4.5h-9V6c0,0.414-0.336,0.75-0.75,0.75
		S6,6.414,6,6V4.5H2.25C1.836,4.5,1.5,4.836,1.5,5.25V9H22.5z"/>
	<path d="M12.75,21c-1.377,0-2.659-0.617-3.517-1.693c-0.125-0.156-0.181-0.353-0.159-0.552s0.121-0.377,0.277-0.502
		c0.133-0.106,0.299-0.164,0.468-0.164c0.229,0,0.443,0.103,0.586,0.282c0.573,0.717,1.427,1.129,2.345,1.129c1.654,0,3-1.346,3-3
		c0-1.654-1.346-3-3-3c-1.028,0.049-1.968,0.621-2.512,1.5h1.106c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75H9
		c-0.414,0-0.75-0.336-0.75-0.75v-3C8.25,12.336,8.586,12,9,12s0.75,0.336,0.75,0.75v0.509c0.806-0.751,1.859-1.207,2.965-1.258
		c0,0,0.001,0,0.001,0c2.509,0,4.534,2.018,4.535,4.499C17.25,18.981,15.231,21,12.75,21z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'calendar-sync',
    },
    name: {
      type: String,
      required: false,
      default: 'CalendarSync',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>